import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';
import Alert from 'flarum/common/components/Alert';
import DecorationStorePurchaseSuccessModal from './DecorationStorePurchaseSuccessModal';

export default class DecorationStorePurchaseModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.itemData = this.attrs.itemData;
    this.moneyName = app.forum.attribute('antoinefr-money.moneyname') || '[money]';

    const itemDiscount = this.itemData.item_discount();
    this.itemID = this.itemData.id();
    this.itemCost = this.itemData.item_cost();
    this.itemCostDiscounted = this.itemCost*((100-itemDiscount)/100);
  }

  className() {
    return 'Modal--small';
  }

  title() {
    return app.translator.trans('ziven-decoration-store.forum.purchase-confirmation');
  }

  content() {
    const moneyNameText = this.moneyName.replace('[money]', app.session.user.attribute("money"));
    const availableAmount = this.itemData.item_amount()-this.itemData.item_sold();
    const itemCostDiscountedText = this.moneyName.replace('[money]', this.itemCostDiscounted);
    const itemType = this.itemData.item_type();
    const itemProperty = JSON.parse(this.itemData.item_property());
    const itemPropertyImage = itemProperty.image;

    let itemImageStyle = "";
    if(itemType==="profileBackground"){
      itemImageStyle = "background-image:url("+itemPropertyImage+")";
    }

    return (
      <div className="Modal-body">
        <div className="Form">
          <div id="DecorationStoreConfirmationText" className="DecorationStoreConfirmationText">
            {this.itemData.item_title()}
          </div>
          <div className="DecorationStoreConfirmationTextSecondary">
            {app.translator.trans('ziven-decoration-store.lib.item-cost')}: {itemCostDiscountedText}&nbsp;|&nbsp;
            {app.translator.trans('ziven-decoration-store.forum.user-money-amount')}: {moneyNameText}
          </div>
          <div className="DecorationStoreConfirmationItemImage">
            {itemType==="avatarFrame" && (
              <img className="DecorationItemAvatarImage" src={itemPropertyImage} />
            )}
            {itemType==="profileBackground" && (
              <div className="DecorationItemPurchaseBackgroundImage" style={itemImageStyle}></div>
            )}
            {itemType==="usernameColor" && (
              <div style="font-size:30px;height: 80px;" className="decorationItemUsernameColorStyle">
                <div className={itemPropertyImage}>{app.translator.trans("ziven-decoration-store.forum.item-property-style-text-effect")}</div>
              </div>
            )}
          </div>
          <div style="text-align:center">
            {Button.component(
              {
                className: 'Button decorationButton--green',
                disabled: this.loading,
                type: 'submit'
              },
              app.translator.trans('ziven-decoration-store.lib.confirm')
            )}&nbsp;
            {Button.component(
              {
                className: 'Button transferMoneyButton--gray',
                disabled: this.loading,
                onclick: () => {
                  this.hide();
                }
              },
              app.translator.trans('ziven-decoration-store.lib.cancel')
            )}
          </div>
        </div>
      </div>
    );
  }

  onsubmit(e) {
    //
    e.preventDefault();
    const userMoney = app.session.user.attribute("money");
    const itemCostDiscounted = this.itemCostDiscounted;

    if(userMoney<itemCostDiscounted){
      app.alerts.show(Alert, {type: 'error'}, app.translator.trans('ziven-decoration-store.forum.purchase-error-insufficient-fund'));
      return;
    }

    const itemID = this.itemID;
    const decorationStorePurchaseData = {
      itemID:itemID,
    };

    $("#DecorationStoreConfirmationText").text(app.translator.trans('ziven-decoration-store.forum.processing'));
    this.loading = true;

    app.store
      .createRecord("decorationStorePurchase")
      .save(decorationStorePurchaseData)
      .then(
        (purchaseData) => {
          app.store.pushPayload(purchaseData);
          app.modal.show(DecorationStorePurchaseSuccessModal);
          app.store.getById('decorationStoreList', this.itemID).data.attributes.purchase_id = purchaseData.id();
          app.store.getById('decorationStoreList', this.itemID).data.attributes.item_sold+=1;
          app.session.user.data.attributes.money-=itemCostDiscounted;
          this.loading = false;
          m.redraw();
        }
      )
      .catch((e) => {
        $("#DecorationStoreConfirmationText").text(app.translator.trans('ziven-decoration-store.forum.purchase-confirmation'));
        this.loading = false;
      });
  }
}
